export enum ImageFormat {
  PNG = 'png',
  WEBP = 'webp',
  AVIF = 'avif',
}
export enum ImageSize {
  S100 = 100,
  S200 = 200,
  S500 = 500,
  S768 = 768,
  S1024 = 1024,
  S1366 = 1366,
  S1600 = 1600,
  S1920 = 1920,
}

export function getOptimizedImageUrl(baseUrl: string, size: ImageSize, format: ImageFormat) {
  // Example base URL:
  // https://media.crystallize.com/nuki-beta/24/10/8/4/smart-lock-pro-1.png
  // Transform it into:
  // https://media.crystallize.com/nuki-beta/24/10/8/4/@size/smart-lock-pro-1.format

  const urlParts = baseUrl.split('/');
  const filename = urlParts.pop();
  const path = urlParts.join('/');

  if (!filename) {
    return baseUrl;
  }

  const [baseName] = filename.split('.');

  const optimizedUrl = `${path}/@${size}/${baseName}.${format}`;
  return optimizedUrl;
}
